import React, {useState} from 'react';
import PropTypes from 'prop-types';
import AdjustItemMpTableRow from "./AdjustItemMpTableRow";
import {Table} from "reactstrap";
import {isEmpty} from "lodash";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const AdjustTable = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [itemMpData, setItemMpData] = useState(props.itemMpData)

  useDidMountEffect(() => {
    if(isEmpty(itemMpData)){
      apiUser.tecRmi.adjust.itemMpData({
        ...getApiPrimaryParams(),
        printView: false,
        linkUrl: '',
        itemMpId: props.itemMpId,
      })
        .then(res =>setItemMpData(res.data))
    }
  })

  if(isEmpty(itemMpData)){
    return <LoadingSpinner />
  }

  return (
    <Table className="table-bordered table-sm table-hover">
      <tbody>
      <AdjustItemMpTableRow itemMp={itemMpData} />
      </tbody>
    </Table>
  );
};

AdjustTable.propTypes = {
  itemMpId: PropTypes.number.isRequired,
  itemMpData: PropTypes.array,
};

export default AdjustTable;